import React from "react";
import Hero from "../components/Hero";

const Home: React.FC = () => {
  return (
    <>
      <Hero />
    </>
  );
};

export default Home;
